const ConditionalWrapper = ({ condition, wrapper, defaultWrapper, children }) =>
	condition ? wrapper(children) : defaultWrapper(children);

export default ConditionalWrapper;
